<template>
  <div class="fast-fade">
    <MarketingMessageTitle v-if="currentStep === 'title'" />
    <MarketingMessageDescription v-if="currentStep === 'description'" />
  </div>
</template>

<script>
import stepable from '../mixins/stepable'

import MarketingMessageTitle from './MarketingMessageTitle.vue'
import MarketingMessageDescription from './MarketingMessageDescription.vue'

export default {
  name: 'MarketingMessage',
  components: {
    MarketingMessageTitle,
    MarketingMessageDescription
  },
  mixins: [stepable]
}
</script>

<style lang="scss">
.fast-help-modal {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom right;
  padding: 0 16px;
}

.fast-help-modal::before {
  content: '';
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 2rem;
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 15px solid white;
}

.fast-help-modal h3 {
  font-size: 18px;
  line-height: 1.24;
}

.fast-help-modal-content {
  font-size: 15px;
  line-height: 1.2;
  padding: 16px 0;
}

@media (min-width: 768px) {
  .fast-help-modal {
    padding: 0 24px;
  }

  .fast-help-modal h3 {
    font-size: 20px;
    line-height: 1.24;
  }

  .fast-help-modal-content {
    padding: 32px 120px 42px 0;
  }
}
</style>
